import { enableProdMode, provideZoneChangeDetection } from '@angular/core';

import { registerLocaleData } from '@angular/common';
import localeDE_CH from '@angular/common/locales/de-CH';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { coreProviders } from './app/providers/core.providers';
import { interceptorProviders } from './app/providers/interceptor.providers';
import { materialProviders } from './app/providers/material.providers';
import { sentryProviders } from './app/providers/sentry.providers';
import { thirdPartyProviders } from './app/providers/third-party.providers';
import { environment } from './environments/environment';

registerLocaleData(localeDE_CH, 'de-CH');

if (environment.production) {
  enableProdMode();
}

// can be removed after 2 prod deployments
// this will deinstall the service worker, if present to make a smoth transistion to remove sw
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister();
    });
  });
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    ...coreProviders,
    ...sentryProviders,
    ...interceptorProviders,
    ...materialProviders,
    ...thirdPartyProviders,
  ],
}).catch((err) => console.error(err));
